"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var styled_components_1 = __importDefault(require("styled-components"));

var selector_1 = require("./selector");

var withSelector_1 = require("./withSelector");

var mobx_react_1 = require("mobx-react");

var withConfiguration_1 = require("./withConfiguration"); // tslint:disable-next-line: function-name


function InjectedStyledComponent(componentOrElement, categoryKey, componentKey, childStyleKeys, rawCssPrefix, rawCssSuffix) {
  if (typeof componentOrElement !== 'string') {
    componentOrElement = withConfiguration_1.withConfiguration(componentOrElement);
  }

  var selector = selector_1.getSelector.apply(void 0, __spreadArrays([categoryKey, componentKey], childStyleKeys || []));
  var className = getComponentClassName.apply(void 0, __spreadArrays([categoryKey, componentKey], childStyleKeys || []));
  var response = styled_components_1.default(componentOrElement)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t", "\n\t\t", "\n\t\t", "\n\t"], ["\n\t\t", "\n\t\t", "\n\t\t", "\n\t"])), rawCssPrefix || '', function (props) {
    var theme = props.theme;
    var componentStyle = getComponentStyle.apply(void 0, __spreadArrays([theme, categoryKey, componentKey], childStyleKeys || []));
    var css = ksys_app_template_1.utils.componentStyle.getCss(componentStyle, props);
    return css;
  }, rawCssSuffix || '');
  return mobx_react_1.observer(withSelector_1.withSelector(response, selector, className));
}

exports.InjectedStyledComponent = InjectedStyledComponent;

function getComponentStyle(theme, categoryKey, componentKey) {
  var childKeys = [];

  for (var _i = 3; _i < arguments.length; _i++) {
    childKeys[_i - 3] = arguments[_i];
  }

  var response = undefined;

  if (theme) {
    var category = (theme || {})[categoryKey];

    if (category) {
      response = category[componentKey];

      if (childKeys) {
        for (var _a = 0, childKeys_1 = childKeys; _a < childKeys_1.length; _a++) {
          var childKey = childKeys_1[_a];

          if (response && response.children && response.children[childKey]) {
            response = response.children[childKey];
          } else {
            response = undefined;
            break;
          }
        }
      }
    }
  }

  return response;
}

function getComponentClassName(categoryKey, componentKey) {
  var childKeys = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    childKeys[_i - 2] = arguments[_i];
  }

  if (childKeys && childKeys.length > 0) {
    return "-ksys-" + childKeys[childKeys.length - 1];
  }

  return "-ksys-" + categoryKey + "-" + componentKey;
}

var templateObject_1;